"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Grid = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    position: absolute;\n    top: calc(1em + 10px);\n    width: calc(100% - 2em);\n    z-index: 50;\n  }\n\n  & div.grid__row {\n    height: 80px;\n    display: flex;\n    border: 1px dashed #f6f6f6;\n  }\n\n  & div.grid__row:not(:last-child) {\n    border-bottom: none;\n  }\n\n  & div.grid__col {\n    height: 100%;\n  }\n\n  & div.grid__col:not(:last-child) {\n    border-right: 1px dashed #f6f6f6;\n  }\n"])));

var GridDivider = function GridDivider(props) {
  var container = props.container,
      showDividers = props.showDividers,
      setRow = props.setRow,
      cols = props.cols,
      setCol = props.setCol,
      rowHeight = props.rowHeight;

  if (!showDividers) {
    return null;
  }

  var rowsCount = Math.floor(container ? container.clientHeight / Number(rowHeight) : 450 / Number(rowHeight));
  var colsList = new Array(cols).fill(null);
  var rows = new Array(rowsCount - 1).fill(null).map(function (_row, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "grid__row",
      key: "row_".concat(i),
      onDrop: function onDrop() {
        setRow(i);
      }
    }, colsList.map(function (_col, j) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "grid__col",
        key: "col_".concat(i, "_").concat(j),
        onDrop: function onDrop() {
          setCol(j);
        },
        style: {
          width: "calc(100% / ".concat(cols, ")")
        }
      });
    }));
  });
  return /*#__PURE__*/_react.default.createElement(Grid, null, rows);
};

var _default = GridDivider;
exports.default = _default;